<template>
    <section name="reset password" class="gap-sm flex h-full w-full flex-col">
        <button class="gap-xs font-matter btn-link px-xs flex items-center" @click="$emit('back')">
            <i class="i-arrow-left" />
            Back
        </button>

        <transition name="fade" mode="out-in">
            <div v-if="!sentMail" key="reset">
                <div class="gap-md flex flex-col items-center justify-center">
                    <i class="i-rotate h-12 w-12" />
                    <div class="gap-xs flex flex-col">
                        <h1>Reset Password</h1>
                        <p>Enter your email address that you use with your account to continue</p>
                    </div>
                    <form class="gap-md flex w-full flex-col" @submit.prevent="handleSubmit">
                        <div class="input-wrapper">
                            <input v-model="formData.email" type="email" placeholder="Email" />
                        </div>
                        <Button class="w-full">Continue</Button>
                    </form>
                </div>
            </div>
            <section
                v-else
                key="sent"
                name="email sent"
                class="gap-md flex h-full w-full flex-col items-center justify-center"
            >
                <i class="i-mail block h-12 w-12" />
                <div class="gap-sm flex flex-col items-center text-center">
                    <h1>We have sent you an email!</h1>
                    <p>
                        If an account exists for <strong>{{ formData.email }}</strong
                        >, you will get an email with instructions on resetting your password.
                    </p>
                </div>
            </section>
        </transition>
    </section>
</template>

<script setup lang="ts">
import { Button } from '@/components/ui/button';
import { ref } from 'vue';

const sentMail = ref(false);
const emit = defineEmits(['back', 'reset']);
const formData = ref({
    email: '',
});

function handleSubmit() {
    emit('reset', formData.value.email);
    sentMail.value = true;
}
</script>

<style scoped>
@reference '@/assets/styles/default.css';

/* Example CSS for the fade transition */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
    opacity: 0;
}
</style>
